import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth-interceptor';
import { HttpErrorInterceptor } from './error-interceptor';
import { ResponseWrapperInterceptor } from './response-wrapper-interceptor';
import { TimeZoneInterceptorService } from './time-zone-interceptor';
import { UserInjectionInterceptor } from './user-injection.interceptor';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ResponseWrapperInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: UserInjectionInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TimeZoneInterceptorService,
        multi: true
    }
];
